
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Ratio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalculateFactor"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"base"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"installment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expectation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"policy_year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attained_age"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BenefitFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Benefit"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benefit_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pay_method"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clause_main"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clause_coverage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clause_exclusion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clause_exception"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clause_restriction"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clause_application"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waiting_period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"elimination_period"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"benefit_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"request_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount_ratio"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratio_without_NHI"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount_range"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"according_to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"according_to_source"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"min"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"max"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"benefit_concepts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calculate_rules"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rule_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount_ratio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ratio"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"policy_value_ratio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ratio"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"total_fee_ratio"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Ratio"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"matched_target"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":731}};
    doc.loc.source = {"body":"fragment Ratio on CalculateFactor {\n  base\n  installment\n  expectation\n  policy_year\n  attained_age\n}\n\nfragment BenefitFull on Benefit {\n  _id\n  ticket_id\n  benefit_name\n  pay_method\n  clause_main\n  clause_coverage\n  clause_exclusion\n  clause_exception\n  clause_restriction\n  clause_application\n  waiting_period\n  elimination_period\n  benefit_type\n  request_unit\n  amount_ratio\n  ratio_without_NHI\n  currency_id\n  amount_range {\n    according_to\n    according_to_source\n    min\n    max\n  }\n  benefit_concepts\n  calculate_rules {\n    rule_id\n    amount_ratio {\n      ...Ratio\n    }\n    policy_value_ratio {\n      ...Ratio\n    }\n    total_fee_ratio {\n      ...Ratio\n    }\n    detail\n  }\n  uploader\n  matched_state\n  matched_target\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["Ratio"] = oneQuery(doc, "Ratio");
        
        module.exports["BenefitFull"] = oneQuery(doc, "BenefitFull");
        
